class CloudBackupApi {
    constructor(host, port, isHttps, bond, getToken) {
        this.apiUrl = `http${isHttps ? 's' : ''}://${host}:${port}`;

        this.host = host;
        this.port = port;
        this.isHttps = isHttps;
        this.bond = bond;
        this.getToken = getToken;
    }


    _request(path, method, body) {
        const headers = new Headers();
        headers.append("Accept", "*/*");
        const token = this.getToken ? this.getToken() : null;
        if (token) headers.append("Authorization", `Bearer ${token}`);

        let requestConfig = { method: method, headers: headers };
        if (body) requestConfig.body = body;
        return fetch(new Request(this.apiUrl + path, requestConfig));
    }


    get(path) {
        return this._request(path, "GET").then((res) => {
            return res.json().catch((e) => Promise.resolve({}));
        });
    }

    put(path, data) {
        return this._request(path, "PUT", JSON.stringify(data));
    }

    patch(path, data) {
        return this._request(path, "PATCH", JSON.stringify(data));
    }

    post(path, data) {
        return this._request(path, "POST", JSON.stringify(data));
    }

    delete(path) {
        return this._request(path, "DELETE", JSON.stringify({}));
    }

    request(path, data) {
        if (data) return this.patch(path, data);
        return this.get(path);
    }

    async getBackupsList(folder) {
        return await this.get(`/palantir/backup/${folder}`);
    };

    async deleteBackup(folder, file) {
        return await this.delete(`/palantir/backup/${folder}/${file}`);
    }

    async upload(file, folder) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("folder", folder);

        const token = this.getToken ? this.getToken() : null;
        const headers = { "Accept": "*/*" };
        if (token) headers["Authorization"] = `Bearer ${token}`;

        const response = await fetch(`${this.apiUrl}/palantir/backup/upload`, {
            method: "POST",
            body: formData,
            headers: headers,
        });
        if (!response.ok) {
            throw new Error("Failed to upload file");
        }
        return response;
    }

}


export default CloudBackupApi;




